import React from "react";
import "../styles.css";
import Dashboard from "./Dashboard";
import { useState, useEffect, useCallback } from "react";
import { useActionData, useLocation, Link } from "react-router-dom";
import UserProfileScreen from "./UserProfileScreen";
import Calendar from "react-calendar";
import { API_IP } from "../global_variables";
import { axiosReqConfig } from "../functions/axiosRequest";
import Modal from "./UserCalendarScreen/CalendarMainModal";
import PromptModal from "./ReuseComponent/PromptModal";
import { set } from "date-fns";
// This is where the user ends up after logging in, or clicking "Home" in the navbar.

const UserCalendarScreen = ({ setSelectedSection }) => {
  const username = localStorage.getItem("username");
  const [isRefresh, setIsRefresh] = useState(false);
  const [isCalendarVisible, setIsCalendarVisible] = useState(false);
  const [currentWeekStart, setCurrentWeekStart] = useState(new Date());
  const [events, setEvents] = useState([]);
  const [eventDetail, setEventDetail] = useState([]);
  const [eventStatusStyle, setEventStatusStyle] = useState("");
  const [eventStatus, setEventStatus] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [patientData, setPatientData] = useState([]);
  const [previousEvent, setPreviousEvent] = useState(null);
  const [isPromptVisible, setIsPromptVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [alertContent, setAlertContent] = useState("");
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  const getEventForCalendars = useCallback(async () => {
    const data = await axiosReqConfig(`${API_IP}/api/calendars`, "get", []);
    setEvents(data);
    console.log(data);
  }, [isRefresh]);

  const cancelAppointment = async () => {
    try {
      setIsLoading(true);
      const data = await axiosReqConfig(
        `${API_IP}/api/calendars/${eventDetail.fk_booking_id}`,
        "delete",
        { date: eventDetail.date_day },
      );
      setEventDetail([]);
      toggleIsRefresh();
      setTimeout(() => {
        setIsLoading(false);
        togglePrompt();
      }, 2000);
    } catch (error) {
      alert(error);
    }
  };
  const toggleAlert = () => {
    setIsAlertVisible(!isAlertVisible);
  };
  const togglePrompt = () => {
    if (isPromptVisible == false && eventStatus == "Accepted") {
      setAlertContent(
        "You can only cancel an appointment that has not been accepted or still pending by any provider!",
      );
      setIsAlertVisible(true);
    } else if (eventDetail.length == 0) {
      setAlertContent("Please select a pending appointment");
      setIsAlertVisible(true);
    } else {
      setIsPromptVisible(!isPromptVisible);
    }
  };

  const toggleIsRefresh = () => {
    setIsRefresh(!isRefresh);
  };

  const selectEvent = (selectedEvent, index, event_style, event_status) => {
    console.log(selectedEvent);
    if (previousEvent !== null) {
      previousEvent.selected = false;
    }
    setPreviousEvent(selectedEvent);
    selectedEvent.selected = true;
    setEventDetail(selectedEvent);
    setEventStatusStyle(event_style);
    setEventStatus(event_status);
  };

  const dayNames = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const timeList = [
    "7:00",
    "8:00",
    "9:00",
    "10:00",
    "11:00",
    "12:00",
    "1:00",
    "2:00",
    "3:00",
    "4:00",
    "5:00",
    "6:00",
    "7:00",
    "8:00",
    "9:00",
    "10:00",
  ];
  const formatDate = (date) => {
    const options = { month: "long", day: "numeric", year: "numeric" };
    return new Intl.DateTimeFormat("en-US", options).format(date);
  };

  const getStartOfWeek = (date) => {
    const startOfWeek = new Date(date);
    const day = startOfWeek.getDay();
    const diff = startOfWeek.getDate() - day + (day === 0 ? -6 : 1); // Adjust to get Monday
    return new Date(startOfWeek.setDate(diff));
  };

  const changeWeek = (days) => {
    const newDate = new Date(currentWeekStart);
    newDate.setDate(currentWeekStart.getDate() + days);
    setCurrentWeekStart(getStartOfWeek(newDate));
  };

  const onDateSelect = (date) => {
    setCurrentWeekStart(getStartOfWeek(date));
    setIsCalendarVisible(false); // Hide the calendar after selecting a date
  };

  const weekStart = getStartOfWeek(currentWeekStart);
  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekStart.getDate() + 6);
  const daysOfWeek = [];
  for (let i = 0; i < 7; i++) {
    const currentDay = new Date(weekStart);
    currentDay.setDate(weekStart.getDate() + i);
    daysOfWeek.push(currentDay);
  }
  const getEventPosition = (startTime, endTime) => {
    const [startHour] = startTime.split(":");
    const [endHour] = endTime.split(":");
    const duration = endHour - startHour;
    const startPosition = (startHour - 7) * 100 + (startHour - 7) * 10 + 72;
    return {
      top: `${startPosition}px`,
      height: `${duration * 85 + (endHour - startHour) * 23}px`, // 100px height per hour
    };
  };
  function stripTime(date_day) {
    // Nếu là dữ liệu từ API (String), dùng UTC để lấy chính xác ngày server gửi về
    if (typeof date_day === "string") {
      const date = new Date(date_day);
      return new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
      );
    }

    // Nếu là cột ngày trên lịch (Date Object), dùng Local time như bình thường
    const date = new Date(date_day);
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }
  const getPatientData = async () => {
    const data = await axiosReqConfig(`${API_IP}/api/patients`, "get", []);

    setPatientData(data);
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getEventForCalendars();
      getPatientData();
    }
    return () => {
      isMounted = false;
    };
  }, [getEventForCalendars]);

  return (
    <>
      <Modal
        showModal={showModal}
        handleClose={closeModal}
        patientData={patientData}
        toggleRefresh={toggleIsRefresh}
        setSelectedSection={setSelectedSection}
      />
      <PromptModal
        title="Do you want to cancel this appointment?"
        type="binary"
        showModal={isPromptVisible}
        handleClose={togglePrompt}
        handleConsent={cancelAppointment}
        isLoading={isLoading}
      />
      <PromptModal
        title={alertContent}
        type="alert"
        showModal={isAlertVisible}
        handleClose={toggleAlert}
        isLoading={isLoading}
      />
      <header className="titleContainer">
        <h1>Calendar</h1>
      </header>
      <div className="calendar-body">
        <div className="calendar-left-body">
          <div className="calendar-toolbar">
            <div className="calendar-date-navigation">
              <button
                className="calendar-nav-button"
                onClick={() => changeWeek(-7)} // Navigate to the previous week
              >
                &#9664;
              </button>
              <span
                onClick={() => setIsCalendarVisible(!isCalendarVisible)}
                style={{ cursor: "pointer" }}
              >{`${formatDate(weekStart)} - ${formatDate(weekEnd)}`}</span>
              <button
                className="calendar-nav-button"
                onClick={() => changeWeek(7)} // Navigate to the next week
              >
                &#9654;
              </button>
              {isCalendarVisible && (
                <div className="calendar-picker">
                  <Calendar
                    onClickDay={onDateSelect} // When a day is clicked, jump to that week
                    value={currentWeekStart}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="calendar-note">
            <p>
              This is where you can view your upcoming care visits or book a new
              one. If your calendar is empty, no appointments have been
              scheduled yet.
            </p>
          </div>
          <div className="calendar-showcase">
            <div className="calendar-grid">
              <div className="calendar-time-column">
                <div className="calendar-time-placeholder"></div>{" "}
                {/* Empty div above 7AM */}
                {timeList.map((time, index) => (
                  <div key={index} className="calendar-time-slot">
                    {time}
                  </div>
                ))}
              </div>

              <div className="calendar-day-columns">
                {daysOfWeek.map((date, index) => (
                  <div key={index} className="calendar-day-column">
                    <div className="calendar-day-label">
                      {date.toLocaleDateString("en-US", {
                        weekday: "long",
                      })}
                      <p></p>
                      {date.toLocaleDateString("en-US", {
                        day: "numeric",
                      })}
                    </div>
                    {events
                      .filter(
                        (event) =>
                          stripTime(date).getTime() ===
                          stripTime(event.date_day).getTime(),
                      )
                      .map((event, eventIndex) => {
                        const style = getEventPosition(
                          event.start_time,
                          event.end_time,
                        );
                        let event_style;
                        let event_status;
                        switch (event.booking_acceptance) {
                          case true:
                            if (event.date_acceptance) {
                              event_style = "calendar-event-accepted";
                              event_status = "Accepted";
                            } else {
                              event_style = "calendar-event-denied";
                              event_status = "Denied";
                            }
                            break;
                          case null:
                            event_style = "calendar-event-pending";
                            event_status = "Pending";
                            break;
                          case false:
                            event_style = "calendar-event-denied";
                            event_status = "Denied";
                            break;
                          default:
                            event_style = "calendar-event-pending";
                            event_status = "Pending";
                            break;
                        }
                        return (
                          <div
                            key={eventIndex}
                            className={`calendar-event ${event_style} ${
                              event.selected ? "calendar-event-selected" : ""
                            }`}
                            onClick={() =>
                              selectEvent(
                                event,
                                eventIndex,
                                event_style,
                                event_status,
                              )
                            }
                            style={style}
                          >
                            <strong>{event.provider_name}</strong>
                            <div>
                              {event.start_time} - {event.end_time}
                            </div>
                          </div>
                        );
                      })}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="calendar-right-body">
          <div className="calendar-rbody-title">
            <h2>Detail</h2>
          </div>
          <div className="calendar-rbody-textBox">
            {eventDetail.length == 0 ? (
              <>
                <p className="calendar-rbody-text">
                  You don’t have any appointments scheduled yet, or none are
                  selected.
                </p>
                <p className="calendar-rbody-text">
                  To get started, click{" "}
                  <span style={{ fontWeight: "bold" }}>
                    “Book a Care Visit”
                  </span>{" "}
                  below and choose a service, date, and time.
                </p>
                <p className="calendar-rbody-text">
                  If you’d like help using this page, we’re happy to guide you.
                  Click this link (add link to tutorial), or the Tutorial link
                  on the left or request a free platform orientation (add link
                  to free platform orientation form)
                </p>
              </>
            ) : (
              <>
                <div>
                  <h1>{eventDetail.provider_name}</h1>
                  <h4>Booking Status For </h4>
                  <h3 className={`${eventStatusStyle}`}>{eventStatus}</h3>
                </div>
                <div>
                  <h5>Time</h5>
                  <h3>
                    {eventDetail.start_time} - {eventDetail.end_time}
                  </h3>
                </div>
                <div>
                  <h5>Description:</h5>
                  <h3>{eventDetail.care_service_name}</h3>
                </div>
                <div>
                  <h5>Client:</h5>
                  <h3>
                    <span className="calendar-patient-name">
                      {eventDetail.patient_first_name}{" "}
                      {eventDetail.patient_last_name}
                    </span>
                  </h3>
                </div>
              </>
            )}
          </div>
          <div className="calendar-rbody-buttonBox">
            <Link onClick={openModal} className="calendar-rbody-button">
              Book a Care Visit
            </Link>
            {/* <Link className="calendar-rbody-button">Edit an Appointment</Link> */}
            <Link
              className={
                eventDetail.length == 0
                  ? "calendar-rbody-button-empty"
                  : "calendar-rbody-button"
              }
              onClick={togglePrompt}
            >
              Cancel an Appointment
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserCalendarScreen;
